import './Offer.css'
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
const Offer = ({offer}) => {
    return (
        <div className={"col-md-3 col-lg-3 col-sm-12 col-xs-12"}>
            <div className="offre">
                <div className={"offer-head"} style={{
                    backgroundColor: offer.color
                }}>
                    <h2 className={"offer-detail-title"}>{offer.title}</h2>
                    <p className={"offer-pricing-message"}>{offer.description}</p>
                </div>
                <div className={"offers-detail"}>
                    <p className={"offer-pricing-container"}>
                        <span className={"offer-pricing"}>{offer.price}</span>Ar/mois
                    </p>
                    <h3 className={"offer-service-title"}>Services accompagnés :</h3>
                    <ul className={"liste-cercles yellow"}>
                        {
                            offer.services.map(service => (
                                <li> <FontAwesomeIcon icon={faCheck} style={{
                                    color: 'var(--green-text)',
                                    fontSize: 'var(--header-text-size-midle)',
                                }}/> {service}</li>
                            ))
                        }
                    </ul>
                    <h3 className={"offer-service-title"}>Fonctionnalités :</h3>
                    <ul className={"liste-cercles blue"}>
                        {
                            offer.features.map(feature => (
                                <li> <FontAwesomeIcon icon={faCheck} style={{
                                    color: 'var(--green-text)',
                                    fontSize: 'var(--header-text-size-midle)',
                                }}/> {feature}</li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Offer;
